module.exports = __webpack_public_path__ + "img/handle_banner1.f1b4d191.png";